import PropTypes from 'prop-types';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import { emptyArray } from 'ui-components/default-props/empty';

export const BadRequestComponent = ({ className = null, messages = emptyArray }) =>
  messages && messages.map((m, i) => <BannerMessageV2 key={i} className={className} content={m} status={BannerStatus.Error} />);

BadRequestComponent.propTypes = {
  className: PropTypes.string,
  messages: PropTypes.array,
};
